webpackJsonp([5],{

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(120);
module.exports = __webpack_require__(121);


/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// $('.toproom-share').hover(function () {
//         $('.sharepanel').show();
//     },
//     function () {
//         $('.sharepanel').hide();
//     }
// );

$('body').on('mouseenter', '.toproom-share', function () {
    var x = $(this).offset();
    x.left -= 20;
    $('.sharepanel').css('left', x.left + 'px');
    // $('.sharepanel').css('top', x.top + 'px');

    $('.sharepanel').show();
});
$('body').on('mouseleave', '.toproom-share', function () {
    setTimeout('hidedropdown()', 200);
});

function hidedropdown() {
    if ($('.sharepanel').data('show') != 'true') {
        $('.sharepanel').hide();
    }
}

$('.sharepanel').hover(function () {
    $('.sharepanel').data('show', 'true');
    $('.sharepanel').show();
}, function () {
    $('.sharepanel').hide();
    $('.sharepanel').data('show', 'false');
});

/***/ })

},[119]);


// WEBPACK FOOTER //
// js/toproom66edcf.js